// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"S1-z"};